var map = {
	"./1.jpg": "122a",
	"./2.jpg": "17f8",
	"./3.jpg": "996a",
	"./4.jpg": "11e2",
	"./5.jpg": "767b",
	"./6.jpg": "35a8",
	"./7.jpg": "08e9",
	"./8.jpg": "ce31"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3d4c";